export default "__VITE_ASSET__2050c449__"